import React, { useEffect, useState } from 'react';
import DisplayDatabases from '../Components/DbConnection/DisplayDatabases';
import { Box, Typography, IconButton } from '@mui/material';
import useQuery from '../hooks/useQueryParams';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDbConnection } from '../hooks/useDbConnection';
import { permissions } from '../Components/CommonFunctions/aliases';
import { PopUpSpinner } from '../Components/CommonFunctions/DialogComponents';
import ActionButtons from '../Components/DbConnection/ActionButtons';
import { fontSize } from '..';
import Fields from '../Components/DbConnection/Fields';
import { getKey } from '../Components/CommonFunctions/CommonFunctions';
import { palette } from '..';
import { Helmet } from 'react-helmet-async';
/***
 * @workspaceid query parameter
 */
const EditDbConnection = () => {
  const { workspaceid } = useQuery('workspaceid');
  const { connectionId } = useParams();
  const navigate = useNavigate();
  const [disableEdit, setDisableEdit] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const { loading, error, result } = useDbConnection(connectionId!, workspaceid!);
  const [info, setInfo] = useState<any>(null);
  useEffect(() => {
    if (result) {
      setInfo(result);
      setDisableEdit(!result.privilege || result.privilege === permissions.view);
    }
  }, [result]);

  const updateValue = (label: string, value: any) => {
    const key = getKey(label);
    if (info?.[key] !== value) {
      setInfo((prev: any) => ({ ...prev, [key]: value }));
    }
  };
  if (loading) {
    return (
      <PopUpSpinner
        show={loading}
        paperProps={{
          sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
        }}
      />
    );
  }
  if (error) {
    return (
      <Box sx={{ display: 'flex', height: '100%' }}>
        <div style={{ color: 'red' }}>{error.message}</div>
      </Box>
    );
  }

  return (
    <>
      <Helmet prioritizeSeoTags defer>
        <title>{`${info?.connectionName ? `${info.connectionName} - DB Connection | Silzila` : 'DB Connection | Silzila'}`}</title>
      </Helmet>
      <Box sx={{ display: 'flex', height: '100%' }}>
        {/* No onClick is required as we cannot change the vender */}
        <DisplayDatabases canChangeDatabase={false} onClick={() => {}} selectedDb={info?.vendor} />

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            flex: 1,
          }}
        >
          <Box
            sx={{
              flex: 1,
              backgroundColor: 'white',
              position: 'relative',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                cursor: 'pointer',
                width: 'fit-content',
                marginTop: '11px',
                marginLeft: '6px',
              }}
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon sx={{ color: 'grey' }} />
              <Typography sx={{ color: 'grey', fontSize: fontSize.medium }}>Back</Typography>
            </Box>

            <Typography
              variant="h6"
              sx={{
                fontSize: fontSize.extraLarge,
                paddingBlock: '0.5rem',
                mb: 2,
                position: 'sticky',
                top: 0,
                color: palette.primary,
                backgroundColor: 'white',
              }}
            >
              {viewMode ? 'DB Connection' : 'Create DB Connection'}
            </Typography>
            <Fields info={info} viewMode={viewMode} updateValues={updateValue} />
          </Box>
          <Box
            sx={{
              height: '3rem',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ActionButtons
              viewMode={viewMode}
              setViewMode={setViewMode}
              disableEdit={disableEdit}
              info={info}
              update
              workspaceId={workspaceid!}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default EditDbConnection;
